export default {
    SEND_CREATE_SCRATCH: "[zina_flow][non-sode] send create scratch",
    SEND_CREATE_SCRATCH_SUCCESS: "[zina_flow][master_budget] send create scratch SUCCESS",
    SEND_CREATE_SCRATCH_FAIL: "[zina_flow][master_budget] send create scratch FAIL",
    SEND_GRN_JOB: "[zina_flow][non-sode] send grn job",
    SEND_GRN_JOB_SUCCESS: "[zina_flow][non_sode] send grn job SUCCESS",
    SEND_GRN_JOB_FAIL: "[zina_flow][non_sode] send grn job FAIL",
    GET_GRN_HISTORY: "[zina_flow][non-sode] get grn history",
    GET_GRN_HISTORY_SUCCESS: "[zina_flow][non_sode] get grn history SUCCESS",
    GET_GRN_HISTORY_FAIL: "[zina_flow][non_sode] get grn history FAIL",
    SEND_ITEMS_SELECTED_JOB: "[zina_flow][non-sode] send items selected job",
    SEND_ITEMS_SELECTED_JOB_SUCCESS: "[zina_flow][non_sode] send items selected job SUCCESS",
    SEND_ITEMS_SELECTED_JOB_FAIL: "[zina_flow][non_sode] send items selected job FAIL",
    GET_AMEND_HISTORY: "[zina_flow][non-sode] get amend history",
    GET_AMEND_HISTORY_SUCCESS: "[zina_flow][non_sode] get amend history SUCCESS",
    GET_AMEND_HISTORY_FAIL: "[zina_flow][non_sode] get amend history FAIL",
};
